export const gbp = (n, { compact = false, decimals = 0 } = {}) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "£0";
  const opts = compact
    ? { style: "currency", currency: "GBP", notation: "compact", maximumFractionDigits: 1 }
    : {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      };
  return new Intl.NumberFormat("en-GB", opts).format(Number(n));
};

export const pct = (n, decimals = 1) =>
  `${Number(n ?? 0).toFixed(decimals)}%`;

export const dateShort = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
